module.exports = __webpack_public_path__ + "img/menu-actions.b408a332.svg";